const dev = {
  baseURL: "http://localhost:8066", // Development base URL
};

const prod = {
  baseURL: "https://sabhl.matjarepos.com", // Production base URL
};

// Determine which environment we're in and export the appropriate settings
const config = process.env.NODE_ENV === "production" ? prod : dev;


export default config;
